import React from 'react';
import { Text, TextAs, TextSizes, Tooltip } from '@clockout-dev/design-elements';
import styles from './styles/kpi-delta.module.scss';

/**
 * Inline "prior period" label that sits at the tail of a KPI delta row.
 * When a `tooltip` is supplied, the label gains a dotted underline cue and
 * surfaces the prior-period date range on hover; without it, the label
 * renders as plain muted text.
 *
 * `Text` forwards its ref to the DOM node, so the design-elements `Tooltip`
 * can anchor and attach hover listeners without an extra wrapper span.
 */
function KpiPriorPeriod({ tooltip }) {
    if (tooltip) {
        return (
            <Tooltip title={tooltip} placement="bottom">
                <Text
                    as={TextAs.SPAN}
                    size={TextSizes.EXTRA_SMALL}
                    className={`${styles.priorPeriod} ${styles.priorPeriodCue}`}
                >
                    prior period
                </Text>
            </Tooltip>
        );
    }

    return (
        <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.priorPeriod}>
            prior period
        </Text>
    );
}

export default KpiPriorPeriod;
